import { useSelector } from 'react-redux';

import CurrencyAmount from '@components/currency-amount/CurrencyAmount';
import { Switch } from '@components/index';
import { SPLIT_REQUIRED_AMOUNT_MIN } from '@constants/generic';
import testId from '@constants/testId';
import { FormDataType } from '@types';

interface InstallmentSectionProps {
  formData: FormDataType;
  onInputChange: (key: string, value: any) => void;
  isEnabled?: boolean;
}

const InstallmentSection = ({
  formData,
  onInputChange,
  isEnabled = false
}: InstallmentSectionProps) => {
  const { orgConfig } = useSelector((state: any) => state.user);

  const splitRequiredMinAmount =
    orgConfig?.split_required_amount_min || SPLIT_REQUIRED_AMOUNT_MIN;

  const isAnyTermAmountEligibleForInstallment = () => {
    if (!formData.termsList || !formData.isCustomTerm) return false;
    return formData.termsList.some(
      (term) => Number(term.dueAmount) >= splitRequiredMinAmount
    );
  };

  const onAcceptInstallmentCheckboxChange = () => {
    if (isEnabled) {
      onInputChange('paymentInstallment', !formData.paymentInstallment);
      return;
    }

    if (
      !formData.paymentInstallment &&
      (Number(formData.amount) >= splitRequiredMinAmount ||
        isAnyTermAmountEligibleForInstallment())
    ) {
      onInputChange('paymentInstallment', true);
    } else {
      onInputChange('paymentInstallment', false);
    }
  };

  const isDisabled =
    !isEnabled &&
    (formData.isCustomTerm
      ? !isAnyTermAmountEligibleForInstallment()
      : Number(formData.amount) < splitRequiredMinAmount);

  return (
    <div className="flex flex-col">
      <div className="flex items-start gap-2">
        <Switch
          data-testid={testId.groupsPage.paymentInInstallment}
          handleClick={onAcceptInstallmentCheckboxChange}
          value={formData?.paymentInstallment}
          disabled={isDisabled}
        />
        <div className="pb-1">
          <span className="text-base font-semibold text-cofeeNeutral10">
            Accept payments as installments
          </span>
          <div className="text-sm text-cofeeNeutral7">
            {`Members can pay in multiple installments for amounts above `}
            <span className="inline-flex items-baseline">
              <CurrencyAmount
                value={splitRequiredMinAmount}
                symbolClass="!mr-0.5"
              />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InstallmentSection;
